import { Appointment, AppointmentEvent, CalendarEventStatusENUM, CalendarEventTypeEnum } from '../../../types';
import { SeriesIndexEvent } from '../../../store/series/types';

// Adapter: shapes a SeriesIndexEvent into the legacy Appointment fields the
// shared timeline helpers (`buildSeriesTimelineRows`, `findCurrentEvent`) read
// — `id`, `date`, `time`, `eventTypeData.outcome`, `eventTypeData.services`.
//
// Step 1 of the index-doc migration: HA Overview now sources events from
// `indexDoc.events` instead of hydrated `row.events`. This adapter exists only
// so we don't have to change the shared timeline helpers' signatures yet —
// they still serve a non-HA caller in CalendarEvents/SeriesContextSection.
// Remove this adapter once the timeline helpers are migrated to consume
// SeriesIndexEvent directly.
export function indexEventToAppointment(event: SeriesIndexEvent): Appointment {
  const eventTypeData: AppointmentEvent = {
    services: event.serviceIds,
    outcome: event.outcome,
  };

  return {
    id: event.id,
    duration: event.duration,
    status: CalendarEventStatusENUM.ACTIVE,
    date: event.date,
    time: event.time,
    type: CalendarEventTypeEnum.APPOINTMENT,
    createdBy: '',
    eventTypeData,
    createdAt: 0,
    updatedAt: 0,
    isProtected: null,
  };
}

export function indexEventsToAppointments(events: SeriesIndexEvent[]): Appointment[] {
  const result: Appointment[] = [];
  for (let eventsIndex = 0; eventsIndex < events.length; eventsIndex += 1) {
    result.push(indexEventToAppointment(events[eventsIndex]));
  }
  return result;
}
